import { useContext } from "react";
import { OtherBoutikService, OtherBoutikServices, OtherBoutikServicesContext } from "../../context/otherBoutikServices/otherBoutikServicesContext";

export const useOtherBoutikService = (serviceName: string): OtherBoutikService => {
    const servicesContext = useContext(OtherBoutikServicesContext) as OtherBoutikServices;

    if (servicesContext[serviceName] === undefined) {
        throw `${serviceName} is not provided`;
    }

    return servicesContext[serviceName];
};